import "./MenuHierarquia.scss";
import UtilServices from "@services/UtilServices";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import { useNavigate } from "react-router-dom";
import MessageServices from "@services/MessageServices";

export default function MenuHierarquia({
  id,
  data,
  nivel,
  menuAberto,
  setMenuAberto,
  setOpenTodoMenu,
}) {
  const navigate = useNavigate();
  const open = (menuAberto?.[nivel] || null) === id;

  function handleVerificaObj(obj) {
    let filhos = [];
    Object.entries(obj).forEach(([key, value]) => {
      if (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        key !== "icon" &&
        key !== "url" &&
        key !== "label" &&
        key !== "disabled"
      ) {
        filhos.push({ ...value, id: key });
      }
    });
    return filhos;
  }

  const handleClick = () => {
    if (data?.disabled === 1) {
      MessageServices.ShowWarning("Você não tem acesso a esse menu!");
      return;
    }

    if (data?.url) {
      setOpenTodoMenu(false);
      setMenuAberto({}); // Fecha todos os menus
      navigate(data?.url);
      return;
    }

    if (!hasChildren) return;

    setMenuAberto((prev) => ({
      ...prev,
      [nivel]: prev[nivel] === id ? null : id,
    }));
  };

  const filhos = handleVerificaObj(data);
  const hasChildren = filhos.length > 0;

  return (
    <li className={`menu-itens ${data?.disabled === 1 ? "disabled" : ""}`}>
      <div
        className="itens"
        onClick={() => {
          handleClick();
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            paddingLeft: "10px",
          }}
        >
          <span>{UtilServices.stringToJsx(data.icon)}</span>
          <p>{data.label}</p>
        </div>
        {/* seta */}
        {hasChildren && <ButtonIcon Arrow openSetArrow={open} />}
      </div>

      {hasChildren && open && (
        <ul className="menuhierarquia-filho">
          {filhos.map((item, index) => (
            <MenuHierarquia
              key={index}
              id={item.id}
              data={item}
              nivel={nivel + 1}
              menuAberto={menuAberto}
              setMenuAberto={setMenuAberto}
              setOpenTodoMenu={setOpenTodoMenu}
            />
          ))}
        </ul>
      )}
    </li>
  );
}
